import { IChoice } from './../interfaces/question/question.interface'

export const statesChoices: IChoice[] = [
  {
    title: 'AC',
    value: 'AC',
  },
  {
    title: 'AL',
    value: 'AL',
  },
  {
    title: 'AM',
    value: 'AM',
  },
  {
    title: 'AP',
    value: 'AP',
  },
  {
    title: 'BA',
    value: 'BA',
  },
  {
    title: 'CE',
    value: 'CE',
  },
  {
    title: 'DF',
    value: 'DF',
  },
  {
    title: 'ES',
    value: 'ES',
  },
  {
    title: 'GO',
    value: 'GO',
  },
  {
    title: 'MA',
    value: 'MA',
  },
  {
    title: 'MG',
    value: 'MG',
  },
  {
    title: 'MS',
    value: 'MS',
  },
  {
    title: 'MT',
    value: 'MT',
  },
  {
    title: 'PA',
    value: 'PA',
  },
  {
    title: 'PB',
    value: 'PB',
  },
  {
    title: 'PE',
    value: 'PE',
  },
  {
    title: 'PI',
    value: 'PI',
  },
  {
    title: 'PR',
    value: 'PR',
  },
  {
    title: 'RJ',
    value: 'RJ',
  },
  {
    title: 'RN',
    value: 'RN',
  },
  {
    title: 'RO',
    value: 'RO',
  },
  {
    title: 'RR',
    value: 'RR',
  },
  {
    title: 'RS',
    value: 'RS',
  },
  {
    title: 'SC',
    value: 'SC',
  },
  {
    title: 'SE',
    value: 'SE',
  },
  {
    title: 'SP',
    value: 'SP',
  },
  {
    title: 'TO',
    value: 'TO',
  },
]
